export default __webpack_public_path__ + "static/media/image-work-personal-w@3x.c34976f7.webp";